import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../lib/auth";

export default function Pricing() {
  const [overview, setOverview] = useState(null);
  const [loading, setLoading] = useState(false);
  const { user, refresh } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    api.get("/course/overview").then((r) => setOverview(r.data));
    if (user && typeof user === "object") refresh();
  }, []);

  const checkout = async () => {
    if (!user || typeof user !== "object") {
      nav("/register");
      return;
    }
    if (user.has_paid) {
      nav("/dashboard");
      return;
    }
    setLoading(true);
    try {
      const origin = window.location.origin;
      const { data } = await api.post("/payments/checkout", { origin_url: origin });
      window.location.href = data.url;
    } catch (e) {
      alert("Could not start checkout. Please try again.");
    } finally { setLoading(false); }
  };

  const price = overview?.price_usd || 49;

  return (
    <div className="max-w-3xl mx-auto px-6 py-20">
      <div className="text-xs uppercase tracking-[0.25em] text-[#A36B5E] text-center">Enrollment</div>
      <h1 className="font-display text-5xl text-[#2D2A26] text-center mt-3 tracking-tight">
        Lifetime access.
      </h1>
      <p className="mt-6 text-lg text-[#5C5852] text-center max-w-xl mx-auto leading-relaxed">
        One investment. Full curriculum. Reflection journal. Forever.
      </p>

      <div className="mt-16 bg-white border border-[#EAE5D9] rounded-2xl p-10 sm:p-14 shadow-[0_8px_30px_rgba(0,0,0,0.04)]">
        <div className="text-center">
          <div className="font-display text-7xl text-[#2D2A26]">${price}</div>
          <div className="text-sm text-[#8A857D] mt-1">USD · one-time</div>
        </div>
        <ul className="mt-10 space-y-3 max-w-md mx-auto text-[#2D2A26]">
          {[
            "All 9 lessons across 3 Scripture pillars",
            "Personal reflection journal — yours forever",
            "The Inner Room — a quiet, scripture-anchored reflection space",
            "Divine Alignment Assessment + progress tracking",
            "Free preview lesson before you pay",
            "Certificate of completion when you finish all 9 lessons",
            "7-day devotional series delivered to your inbox after enrollment",
            "Direct access to request speaker engagements",
          ].map((f, i) => (
            <li key={i} className="flex gap-3 items-start">
              <span className="text-[#5F6F52] mt-1">✓</span>
              <span>{f}</span>
            </li>
          ))}
        </ul>

        <div className="mt-12 text-center">
          {user && typeof user === "object" && user.has_paid ? (
            <button onClick={() => nav("/dashboard")} data-testid="pricing-already-paid" className="btn-primary rounded-full px-10 py-4 font-medium">
              You have full access — Go to course
            </button>
          ) : (
            <button onClick={checkout} disabled={loading} data-testid="pricing-checkout" className="btn-primary rounded-full px-10 py-4 font-medium disabled:opacity-50">
              {loading ? "Redirecting..." : `Enroll · $${price}`}
            </button>
          )}
          <div className="mt-5 text-xs text-[#8A857D]">
            Secure checkout via Stripe. Lifetime access — no subscription.
          </div>
        </div>
      </div>

      <div className="mt-12 text-center italic text-[#5C5852]">
        "Trust in the Lord with all your heart and lean not on your own understanding."
        <div className="not-italic text-xs tracking-widest uppercase mt-1 text-[#8A857D]">— Proverbs 3:5</div>
      </div>
    </div>
  );
}
